import React, { useState } from 'react';
import WithdrawlTable from './components/WithdrawlTable';
import { searchBankAccount, getTenantBalance } from '../../api/sportaloka-client';

function Withdrawl() {
  const [initLoading, setInitLoading] = useState();
  const [initError, setInitError] = useState();
  const [bankAccounts, setBankAccounts] = useState([]);
  const [balance, setBalance] = useState(0);
  const [totalFilter, setTotalFilter] = useState(4);

  const init = async () => {
    try {
      setInitLoading(true);
      setInitError(false);
      const response = await searchBankAccount();
      const responseData = response.data.data;
      const balanceResponse = await getTenantBalance();
      setBalance(balanceResponse.data.data.balance);
      setBankAccounts(responseData);
      setInitLoading(false);
    } catch (error) {
      setInitError(true);
      setInitLoading(false);
    }
  };

  const handleSubmit = () => {
    init();
  };

  useState(() => {
    init();
  }, []);
  return (
    <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h1 className="text-30 lh-14 fw-600">Penarikan Saldo</h1>
            {!initLoading && initError && (
              <p className="text-dark fw-400">
                Gagal mendapatkan data{' '}
                <span className="fw-600 text-danger cursor-pointer" onClick={init}>
                  Coba Kembali
                </span>
              </p>
            )}
            {initLoading && !initError && <p className="text-dark fw-400">Loading...</p>}
            {!initLoading && !initError && (
              <p className="text-dark fw-400">
                Saldo Saat ini:{' '}
                <span className="fw-700 text-blue-1">
                  IDR {balance ? balance.toLocaleString('id-ID') : 0}
                </span>
              </p>
            )}
          </div>

          <div className="d-flex">
            <button
              type="button"
              className="button -md h-50 bg-blue-1 text-white mr-20"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal">
              <i className="fa fa-filter mr-10" />
              Filter Data ( {totalFilter > 0 ? totalFilter : 0} )
            </button>
            <button
              type="button"
              className="button -md h-50 bg-blue-1 text-white"
              data-bs-toggle="modal"
              data-bs-target="#withdrawBalanceModal">
              <i className="fa fa-money mr-10" />
              Tarik Saldo
            </button>
          </div>
        </div>
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20" style={{ minHeight: 540 }}>
          <WithdrawlTable
            onSubmmited={handleSubmit}
            bankAccounts={bankAccounts}
            onFilterLengthChanged={(val) => setTotalFilter(val)}
          />
        </div>
      </div>
    </div>
  );
}

export default Withdrawl;
